export default __webpack_public_path__ + "static/media/miguel.89141e37.png";